module.exports = __webpack_public_path__ + "static/media/wp.69278582.png";